export default __webpack_public_path__ + "static/media/bv.af9b74eb.svg";